const routes = {
  rates: 'Rates',
  parents: 'Parents',
  newScenario: 'New Scenario',
  viewSites: 'View Sites',
  sites: 'Sites',
  attributes: 'Attributes',
  suppliers: 'Suppliers',
  updateSupplier: 'Update Supplier',
  createSupplier: 'Create Supplier',
  shuttles: 'Shuttles',
  updateShuttle: 'Update Shuttle',
  createShuttle: 'Create Shuttles',
  fares: 'Fares',
  updateFare: 'Update Fare',
  createFare: 'Create Fare',
  services: 'Services',
  updateService: 'Update Service',
  createService: 'Create Service',
  users: 'Users',
  updateUser: 'Update User',
  createUser: 'Create User',
  vehicles: 'Vehicles',
  updateVehicle: 'Update Vehicle',
  createVehicle: 'Create Vehicle',
  areas: 'Zones',
  updateArea: 'Update Area',
  createArea: 'Create Area',
  drivers: 'Drivers',
  updateDriver: 'Update Driver',
  createDriver: 'Create Driver',
  playground: 'Playground',
  support: 'Support',
  parameters: 'Parameters',
  createParameter: 'Create Parameter',
  analytics: 'Analytics',
  settings: 'Settings',
  liveMap: 'Live Map',
  driverShifts: 'Driver Shifts',
  driverShiftsTemplates: 'Shift Templates',
  createDriverShift: 'Create a Single Driver Shift',
  createMultipleDriverShifts: 'Create Multiple Driver Shifts',
  passengers: 'Passengers',
  students: 'Students',
  employees: 'Employees',
  editShuttle: 'Edit Shuttle',
  updatePassenger: 'Edit Passenger',
  createPassenger: 'New Passenger',
  onlineDrivers: 'Online Drivers',
  trips: 'Trips',
  productionTrips: 'Production Trips',
  reservations: 'Bookings',
  editReservation: 'Edit Booking',
  createReservation: 'Create Booking',
  createQuick: 'Create Quick',
  timeline: 'Timeline',
  feedbacks: 'Feedbacks',
  home: 'Mission Control',
  import: 'Upload Data',
  reports: 'Reports',
  shuttleReports: 'Shuttle Reports',
  locations: 'Locations',
  createLocation: 'Create Location',
  editLocation: 'Update Location',
  profiles: 'Profiles',
  shifts: 'Shifts',
  createShift: 'Create Shift',
  updateShift: 'Update Shift',
  agentHome: 'Agent',
  createExtraService: 'Crete Extra Service',
  updateExtraService: 'Update Extra Service',
  extraServices: 'Extra Services',
  tripsPaxReports: 'Trips / Passengers Summary',
  uniqueDriversReport: 'Unique Drivers Per Day',
  permissions: 'Roles and Permissions',
  createJob: 'Create Reservation',
  quickJob: 'Quick Reservation',
  onboarding: 'Scenario Builder - NEMT',
  holidays: 'Holidays',
  blacklist: 'Card Blacklist',
  integrations: 'Integrations',
  automations: 'Automations',
  jobsCalendar: 'Booking Calendar',
  caregivers: 'Caregivers',
  customRules: 'Custom Rules',
  billReports: 'Bill Reports',
  performanceOverview: 'Performance Overview',
  facilities: 'Facilities',
  roiSimulation: 'ROI Simulation',
  apiKeys: 'API Keys',
};

export default routes;
